import React, { useState, useEffect } from "react";
import { NavItems } from "../data";
import { X, Menu } from "lucide-react";

const Navbar: React.FC = () => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleNavbar = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  // Manejar el cambio de estilo basado en el scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`fixed top-0 z-50 w-full transition-all duration-300 ease-in-out ${
        isScrolled
          ? "bg-white text-black shadow-md border-b"
          : "bg-transparent text-white"
      }`}
    >
      <div className="container px-4 mx-auto relative lg:text-sm">
        <div className="flex justify-between items-center py-3">
          <div className="flex items-center flex-shrink-0">
            <a href="/">
              <h1 className="md:text-5xl text-3xl  font-alex">Estudio Jurídico Barbero</h1>
            </a>
          </div>
          <ul className="hidden lg:flex ml-14 space-x-10">
            {NavItems.map((item, index) => (
              <li key={index}>
                <a
                  className={`font-medium text-lg border-b-[1px] pb-2 ${
                    isScrolled
                      ? "hover:border-black border-transparent"
                      : "hover:border-white border-transparent"
                  }`}
                  href={item.href}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="lg:hidden md:flex flex-col justify-end">
            <button onClick={toggleNavbar}>
              {mobileDrawerOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
        {mobileDrawerOpen && (
          <div className="fixed right-0 z-50 bg-neutral-900 w-full p-12 flex flex-col justify-center items-center lg:hidden">
            <ul>
              {NavItems.map((item, index) => (
                <li key={index} className="my-4">
                  <a className="text-white" href={item.href}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
